@if (claim && petData) {
  <cpf-claims-details [claim]="claim" [petData]="petData"></cpf-claims-details>
}
